// extracted by mini-css-extract-plugin
export default {"Loader":"style_Loader__Qi6i9","load2":"style_load2__456E+"};